import $ from 'jquery';
import BackgroundImage from './BackgroundImage';
import PlayPauseControls from './PlayPauseControls';
import 'slick-carousel';

const defaults = {
  speed: 1000,
  fade: true,
  dots: true,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 4000,
  pauseOnFocus: false,
  waitForAnimate: false,
  appendDots: '.slick-toolbar',
};

export default class Gallery {
  constructor(element, options) {
    this.element = element;
    this.$element = $(element);
    this.settings = Object.assign({}, defaults, options);
    this.preprocess();
    this.carousel = this.build();
    this.controls = this.addControls();
    this.ready();
  }

  preprocess() {
    // Add background images.
    this.$element.find('.node').each((i, element) => {
      element.BackgroundImage = new BackgroundImage(element);
    });
    // Add a container to place all slick nav and play/pause controls in.
    this.$element.find('.view').append('<div class="slick-toolbar"></div>');
  }

  build() {
    return this.$element.find('.view-content').slick(this.settings);
  }

  addControls() {
    return new PlayPauseControls(this.carousel, { attachTo: this.$element.find('.slick-toolbar') });
  }

  ready() {
    this.$element.addClass('ready');
  }
}
